(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["greif-gallery-lightbox"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('DOMContentLoaded', function() {
      var sections = document.querySelectorAll('[data-greif-gallery-section]');
      if (!sections.length) return;

      sections.forEach(function(section) {
        var items = section.querySelectorAll('[data-greif-gallery-open]');
        var lightbox = section.querySelector('[data-greif-gallery-lightbox]');
        var lightboxImg = section.querySelector('.greif-gallery__lightbox-image');

        if (!items.length || !lightbox || !lightboxImg) return;

        items.forEach(function(item) {
          item.addEventListener('click', function() {
            var imgSrc = item.getAttribute('data-image');
            var imgAlt = item.getAttribute('data-alt') || '';

            if (!imgSrc) return;

            // width/height (für Theme-Check) zur Laufzeit entfernen,
            // damit das Bild nicht verzerrt wird
            lightboxImg.removeAttribute('width');
            lightboxImg.removeAttribute('height');

            lightboxImg.src = imgSrc;
            lightboxImg.alt = imgAlt;
            lightbox.removeAttribute('hidden');
            document.body.classList.add('greif-gallery-open');
          });
        });

        function closeLightbox() {
          lightbox.setAttribute('hidden', 'hidden');
          lightboxImg.src = '';
          lightboxImg.alt = '';
          document.body.classList.remove('greif-gallery-open');
        }

        section.querySelectorAll('[data-greif-gallery-close]').forEach(function(el) {
          el.addEventListener('click', function() {
            closeLightbox();
          });
        });
      });

      // ESC schließt alle offenen Lightboxen
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          var openLightboxes = document.querySelectorAll('[data-greif-gallery-lightbox]:not([hidden])');
          if (!openLightboxes.length) return;

          openLightboxes.forEach(function(lightbox) {
            var img = lightbox.querySelector('.greif-gallery__lightbox-image');
            if (img) {
              img.src = '';
              img.alt = '';
            }
            lightbox.setAttribute('hidden', 'hidden');
          });

          document.body.classList.remove('greif-gallery-open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
